export const getItemUnits = (productId: number, selectedMenuItems: any[]) => {
  const count = selectedMenuItems.filter(
    (selectedItem) => selectedItem.productId === productId
  )?.length
  if (count) {
    const unitSellCode = selectedMenuItems?.find(
      (sMI) => sMI.productId === productId
    )?.unitSellCode
    switch (unitSellCode) {
      case 2:
        return `${count * 100}g`
      case 3:
        return `${count}kg`
      default:
        return `${count}`
    }
  }
}
